// La moneda del anuncio: una sola para el anuncio, sus alojamientos y sus tarifas.
export const monedaAnuncio = {
  chipTitle: "Devise de l'annonce",
  change: "Modifier",
  mismatchDot: "Les devises de cette annonce ne correspondent pas",
  channexText: "Cette annonce est connectée à Channex. La devise d'un tarif ne peut pas y être modifiée : il faut le recréer. Écrivez-nous et nous le ferons sans interrompre vos ventes sur les OTA.",
  channexOnly: "Elle est connectée à Channex : elle ne peut utiliser que {currency}, la devise de ses tarifs là-bas.",
  modal: {
    title: "Devise de l'annonce",
    lead: "C'est la devise dans laquelle vous encaissez les voyageurs de cette annonce.",
    scope: "Elle change en même temps pour l'annonce, tous ses hébergements et ses tarifs. Les liens de paiement, l'agent IA et le départ tardif utiliseront cette devise.",
    label: "Devise",
    mismatch: "Pour l'instant elles ne correspondent pas : l'annonce indique {listing} et ses hébergements encaissent en {units}. En enregistrant, tout sera dans la même.",
    channexTitle: "Impossible de la modifier ici",
    cancel: "Annuler",
    close: "Compris",
    save: "Enregistrer",
    saving: "Enregistrement…",
    saved: "Devise de l'annonce mise à jour : {currency}.",
    error: "Impossible de modifier la devise. Réessayez.",
  },
  sugerencia: {
    titleCountry: "Cette annonce encaisse en {current}",
    textCountry: "En {country}, on paie généralement en {suggested}. Si vous la changez, les liens de paiement, l'agent IA et le départ tardif utiliseront {suggested}.",
    titleMismatch: "Les devises de cette annonce ne correspondent pas",
    textMismatch: "L'annonce indique {listing} et ses hébergements encaissent en {units}. Gardez-en une seule pour que ce qu'annonce l'IA et ce qui est encaissé soient identiques.",
    useSuggested: "Passer en {currency}",
    other: "En choisir une autre",
    keep: "Garder {currency}",
  },
};
